exports.install = function (Vue, {delay = 1300} = {}) {
  Vue.directive('long-press', {
    bind (el, binding, vnode, oldVnode) {
      let _timeout = null

      const cancel = () => { clearInterval(_timeout) }

      const onTouchDown = event => {
        const context = this
        _timeout = setTimeout(() => {
          binding.value.call(context, event)
          cancel()
        }, delay)
      }

      el.addEventListener('touchstart', onTouchDown)
      el.addEventListener('touchend', cancel)
      el.addEventListener('touchcancel', cancel)
    }
  })
}
